import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { Category } from '@/models/category.model';
import { ShiftCMSState } from '@/store';
import { CategoriesActions, CategoriesState } from '@/stores/categories.store';
import { ref, computed, onMounted, PropType, watch } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'CategoriesField',
  props: {
  label: {
    type: String,
  },
  modelValue: {
    type: Array as PropType<Category[]>,
    required: true,
    default: () => [],
  },
  required: {
    type: Boolean,
    default: () => false,
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
  max: {
    type: Number,
    default: 0,
  },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props;

const store = useStore<ShiftCMSState & { cs: CategoriesState }>();
const emit = __emit;

const categories = ref<Category[]>([...(props.modelValue || [])]);

function getParentString(c: Category, categories: Category[]): string {
  if (c.parentCategory) {
    const parent = categories.find((p) => p.id === c.parentCategory?.id);

    if (parent) {
      return `${getParentString(parent, categories)}${parent.title} - `;
    }
  }
  return '';
}

const categoryItems = computed(() =>
  [...store.state.cs.categories]
    .sort((a, b) => a.index - b.index)
    .map((c) => {
      return {
        title: `${
          getParentString(c, store.state.cs.categories)
            ? `${getParentString(c, store.state.cs.categories)}`
            : ''
        }${c.title}`,
        value: c,
      };
    }),
);

function update(v: Category[]) {
  emit('update:modelValue', v);
  emit('change');
}

watch(
  () => props.modelValue,
  () => {
    categories.value = [...props.modelValue];
  },
);

onMounted(() => {
  store.dispatch(CategoriesActions.GetCategories);
});

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_autocomplete, {
      label: 
      props.label
        ? props.label
        : _ctx.$t(
            `${
              __props.max !== 1
                ? 'initiative.edit.categories'
                : props.label
                ? props.label
                : 'initiative.edit.category'
            }`,
          )
    ,
      modelValue: categories.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((categories).value = $event)),
        update
      ],
      items: categoryItems.value,
      disabled: __props.disabled,
      chips: "",
      multiple: "",
      valueComparator: (a, b) => a.id === b.id
    }, {
      item: _withCtx(({ props }) => [
        _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item_title)
          ]),
          _: 2
        }, 1040)
      ]),
      _: 1
    }, 8, ["label", "modelValue", "items", "disabled", "valueComparator"]),
    _createVNode(_component_v_container, { style: {"padding-top":"0","padding-bottom":"0"} }, {
      default: _withCtx(() => [
        (categories.value?.length > __props.max && __props.max !== 0)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 0,
              type: "warning",
              density: "compact"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Only use one category")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        (categories.value?.length === 0 && __props.required)
          ? (_openBlock(), _createBlock(_component_v_alert, {
              key: 1,
              type: "warning",
              density: "compact"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("This is required")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})